module.exports = __webpack_public_path__ + "static/drzwi-optimo-7592bdc8c6827a1383ef28fa873844e1.png";